import { atom, useAtom, useSetAtom } from 'jotai';

const isCurrencyModeActive = atom(false);

export const useCampaignCurrencyMode = () => {
  return useAtom(isCurrencyModeActive);
};

export const useSetCampaignCurrencyMode = () => {
  return useSetAtom(isCurrencyModeActive);
};
